import { render, staticRenderFns } from "./Injected1.vue?vue&type=template&id=0fce3c72&"
import script from "./Injected1.vue?vue&type=script&lang=ts&"
export * from "./Injected1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports